import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Chip from './Chip'
import SelectedBlast from './SelectedBlast'
import { canStillCancel, createTempScheduledFor } from './time-tools'
import {
  getAllBlasts,
  getOneBlast,
  cancelBlast,
} from '../../../state/actions/blast-messages'
import chipCss from './chip.css'

const processCounts = (counts, isCancelled) => {
  // if blast is > 24 hours old, `counts` won't be available in API response
  const ref = counts || { total: 0, pending: 0, failures: 0 }
  ref.sent = isCancelled ? 0 : ref.total - ref.pending - ref.failures
  return ref
}

const renderChips = (blasts, selectedBlastId, handleClick) => blasts.map((blast) => (
  <Chip
    key={blast.id}
    blast={blast}
    isSelected={blast.id === selectedBlastId}
    handleClick={handleClick}
  />
))

class Blasts extends Component {
  static propTypes = {
    blasts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        createdAt: PropTypes.string.isRequired,
        scheduledFor: PropTypes.string.isRequired,
      })
    ).isRequired,
    getAllBlasts: PropTypes.func.isRequired,
    getOneBlast: PropTypes.func.isRequired,
    cancelBlast: PropTypes.func.isRequired,
  }

  state = {
    selectedBlastId: null,
    selectedBlast: {},
    isCancellable: true,
    isCancelConfirmationOpen: false,
  }

  componentDidMount() {
    this.getAllBlasts()
  }

  getAllBlasts = () => {
    return this.props.getAllBlasts().catch(err => console.error(err))
  }

  getOneBlast = (blastId) => {
    return this.props.getOneBlast(blastId).then(res => {
      const emailIds = res['email_ids'] || []
      const scheduledFor = res.scheduled_for || createTempScheduledFor(res.cancelled, res.created_at)
      const isCancelled = !!res.cancelled

      const selectedBlast = {
        id: res.id,
        isEmail: emailIds.length > 0,
        isCancelled,
        scheduledFor,
        counts: processCounts(res.counts, isCancelled),
      }

      this.setState({
        selectedBlast,
        selectedBlastId: blastId,
        isCancellable: canStillCancel(scheduledFor)
      })
    }).catch(err => console.error(err))
  }

  onClickChip = (blastId) => {
    this.getOneBlast(blastId)
  }

  openCancellationDialog = () => {
    const { scheduledFor } = this.state.selectedBlast

    if (scheduledFor && canStillCancel(scheduledFor)) {
      this.setState({ isCancelConfirmationOpen: true })
    } else {
      const msg = 'Sorry, it is too late to cancel this scheduled message'
      window.alert(msg)
    }
  }

  affirmCancellation = () => {
    this.setState({ isCancelConfirmationOpen: false })

    const { selectedBlastId } = this.state

    this.props.cancelBlast(selectedBlastId).then(blast => {
      this.closeSelectedBlastModal()
      this.getAllBlasts()
    }).catch(err => console.error(err))
  }

  denyCancellation = () => {
    this.setState({ isCancelConfirmationOpen: false })
  }

  closeSelectedBlastModal = () => {
    this.setState({ selectedBlastId: null, selectedBlast: {} })
  }

  render() {
    const { selectedBlastId, selectedBlast } = this.state
    const { blasts } = this.props

    if (blasts.length < 1) { return null }

    return (
      <div>
        {selectedBlastId &&
        <SelectedBlast
          blast={{ ...selectedBlast }}
          isCancellable={this.state.isCancellable}
          isCancelConfirmationOpen={this.state.isCancelConfirmationOpen}
          closeSelectedBlastModal={this.closeSelectedBlastModal}
          openCancellationDialog={this.openCancellationDialog}
          affirmCancellation={this.affirmCancellation}
          denyCancellation={this.denyCancellation}
        />
        }
      </div>
    )
  }
}

const mapStateToProps = ({ blastMessages }) => ({ blasts: blastMessages.sent })

const mapDispatchToProps = dispatch => (
  bindActionCreators({ getAllBlasts, getOneBlast, cancelBlast }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Blasts)



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/index.js